<script>
  import { createEventDispatcher } from 'svelte';
  import viewport from '@/js/utils/useViewportAction.js';

  export let nav;
  export let active;

  let bgColor;
  let grow = false;

  const dispatch = createEventDispatcher();

  function scrollToSection(item) {
    dispatch('showActive', item);
  }

  function changeBackground() {
    if (
      document.body.scrollTop > 1700 ||
      document.documentElement.scrollTop > 1700
    ) {
      bgColor = 'white';
    } else {
      bgColor = 'transparent';
    }
  }
</script>

<svelte:window on:scroll={changeBackground} />

<div class="nav" class:grow use:viewport on:enterViewport={() => (grow = true)}>
  <ul class="nav__list" style={`background-color: ${bgColor}`}>
    {#each nav.items as item}
      <li>
        <button
          class="nav__item tagline active"
          class:active={item.id === active}
          on:click={() => {
            scrollToSection(item);
          }}>{item.title}</button
        >
      </li>
    {/each}
  </ul>
</div>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .nav {
    text-align: center;
    position: sticky;
    top: 0;
    padding-bottom: 0;
    z-index: 100;

    @include resp-max('s') {
      margin-bottom: 5rem;
    }

    &.grow {
      animation: fade-up 1s ease-in-out backwards;
    }

    &__list {
      display: flex;
      // margin-top: 3rem;
      justify-content: center;
      flex-wrap: nowrap;
      overflow: auto;

      /* Hide scrollbar for Chrome, Safari and Opera */
      &::-webkit-scrollbar {
        display: none;
      }
      /* Hide scrollbar for IE, Edge and Firefox */
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */

      @include resp-max('m') {
        gap: 3rem;
      }

      @include resp-max('s') {
        justify-content: left;
      }
    }

    li {
      flex-shrink: 0;
      display: flex;
    }

    &__item {
      color: var(--royal-light);
      border-bottom: 1px solid $light-border;
      padding: 1.5rem 4rem;
      font-weight: 700;

      @include resp-max('m') {
        padding: 1.5rem 0;
        border-bottom: 1px solid transparent;
      }

      &:hover {
        border-bottom: 1px solid;
        border-image-slice: 1;
        border-image-source: linear-gradient(135deg, #04a4d7 0%, #24fff2 100%);
        color: var(--royal);
      }

      &.active {
        border-bottom: 1px solid;
        border-image-slice: 1;
        border-image-source: linear-gradient(135deg, #04a4d7 0%, #24fff2 100%);
        color: var(--royal);
      }
    }
  }
</style>
